import { useEffect } from "react";

export function useDebugGate(user: { role?: string | null } | null, setAllowed: (val: boolean) => void) {
  const DEBUG =
    typeof window !== "undefined" &&
    new URLSearchParams(location.search).get("debug") === "1";

  useEffect(() => {
    if (!DEBUG) {
      setAllowed(false);
      return;
    }

    if (user && (user as any)?.role === "admin") {
      setAllowed(true);
      document.dispatchEvent(new Event("gw:debug-ready"));
    } else {
      setAllowed(false);
    }
  }, [DEBUG, user, setAllowed]);

  return DEBUG;
}
